module.exports = __webpack_public_path__ + "img/unknown-technology.f84ab741.jpg";